module.exports = require('./helpers/bundle-url').getBundleURL('dWZnR') + "logo-dark.eefe0b7f.svg";